import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  // root is not a valid path
  // [appPaths.feedback.root]: {
  //   path: appPaths.feedback.root
  // },

  // This must be first, else variables can interfer with matching of "/submit"
  [appPaths.feedback.submitFeedback]: {
    path: appPaths.feedback.submitFeedback
  },
  [appPaths.feedback.deleteFeedback]: {
    path: appPaths.feedback.deleteFeedback
  },
  [appPaths.feedback.editFeedback]: {
    path: appPaths.feedback.editFeedback
  },
  [appPaths.feedback.viewFeedback]: {
    path: appPaths.feedback.viewFeedback
  }
};
